import { createElement } from "react";
import { Link } from "react-router-dom";

const breadcrumbsConfig = {
  "/order-center/purchase/details": [
    {
      key: "/order-center/purchase",
      title: createElement(
        Link,
        { to: "/order-center/purchase" },
        "Purchase Order"
      ),
    },
    {
      key: "/order-center/purchase/details",
      title: createElement(
        Link,
        { to: "/order-center/purchase/details" },
        "Detail"
      ),
    },
  ],

  "/order-center/purchase/reply": [
    {
      key: "/order-center/purchase",
      title: createElement(
        Link,
        { to: "/order-center/purchase" },
        "Purchase Order"
      ),
    },
    {
      key: "/order-center/purchase/reply",
      title: createElement(
        Link,
        { to: "/order-center/purchase/reply" },
        "Reply"
      ),
    },
  ],
};

export default breadcrumbsConfig;
